import { render, staticRenderFns } from "./DSNavigation.vue?vue&type=template&id=38b80be7&"
import script from "./DSNavigation.vue?vue&type=script&lang=js&"
export * from "./DSNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports